
        import * as module0 from './assets/bases/page.js';import * as module1 from './assets/bases/store.js'

        const modules = [module0,module1];

        export default modules;
        export const filenames = ['./assets/bases/page.js','./assets/bases/store.js']
      